<template>
  <div class="room-control">
    <div
      @click="enabledMenu = !enabledMenu; enabledBadge = false"
      class="room-control-button"
    >
      <span class="menu-tooltip">{{ $t('pages.room.tooltip.menu') }}</span>
      <img :src="require('@/assets/images/room/icons/control.png')"/>
      <span v-show="enabledBadge" class="room-control-badge"/>
    </div>
    <transition name="scale">
      <div
        v-show="enabledMenu"
        class="room-control-menu"
      >
        <span v-if="!cafeRoom" class="elapsed-time mr-3 ml-2">{{ elapsedTime }}</span>
        <div
          class="menu"
          @click="$emit('onClickConfig')"
        >
          <span class="menu-tooltip">{{ $t('pages.room.tooltip.config') }}</span>
          <img :src="require('@/assets/images/room/icons/ellipsis-v.png')"/>
        </div>
        <div
          :class="['menu', { 'active': peersInfoState }]"
          @click="$emit('onClickPeersInfo')"
        >
          <span class="menu-tooltip">{{ $t('pages.room.tooltip.member') }}</span>
          <img :src="require('@/assets/images/room/icons/users.png')"/>
          <span v-show="raisedHandsPeersState" class="room-control-badge"/>
        </div>
        <div
          :class="['menu', {
            'active': whiteboardState,
            'disabled': screenShareState
          }]"
          @click="$emit('onClickWhiteboard')"
        >
          <span class="menu-tooltip">{{ $t('pages.room.tooltip.board') }}</span>
          <img :src="require('@/assets/images/room/icons/whiteboard.png')"/>
        </div>
        <div
          v-if="$deviceInfo.isSupportedShare"
          :class="['menu', {
            'active': screenShareState === 1,
            'disabled': screenShareState === 2
          }]"
          @click="$emit('onClickScreenShare')"
        >
          <span class="menu-tooltip">{{ $t('pages.room.tooltip.screenShare') }}</span>
          <img :src="require('@/assets/images/room/icons/screen_share.png')"/>
        </div>
        <div
          :class="['menu', { 'active': chatState }]"
          @click="$emit('onClickChat')"
        >
          <span class="menu-tooltip">{{ $t('pages.room.tooltip.chat') }}</span>
          <img :src="require('@/assets/images/room/icons/chat.png')"/>
          <span v-show="newChatMessagesState" class="room-control-badge">{{ newChatMessagesState }}</span>
        </div>
        <div
          :class="['menu', { 'active': !myWebcamState }]"
          @click="$emit('onClickWebcam')"
        >
          <span class="menu-tooltip">{{ $t(`pages.room.tooltip.${myWebcamState ? 'videoOff' : 'videoOn'}`) }}</span>
          <img :src="require(`@/assets/images/room/icons/webcam_${myWebcamState ? 'on' : 'off'}.png`)"/>
        </div>
        <div
          :class="['menu', { 'active': !myMicState }]"
          @click="$emit('onClickMic')"
        >
          <span class="menu-tooltip">{{ $t(`pages.room.tooltip.${myMicState ? 'mute' : 'unmute'}`) }}</span>
          <img :src="require(`@/assets/images/room/icons/mic_${myMicState ? 'on' : 'off'}.png`)"/>
        </div>
        <div
          :class="['menu', { 'active': myRaisedHandsState }]"
          @click="$emit('onClickRaisedHands')"
        >
          <span class="menu-tooltip">{{ $t(`pages.room.tooltip.${myRaisedHandsState ? 'lowereHand' : 'raiseHand'}`) }}</span>
          <img :src="require('@/assets/images/room/icons/raised_hands.png')"/>
        </div>
        <div
          v-if="isOwner"
          :class="['menu', { 'active': addMemberModalState }]"
          @click="$emit('onClickAddMember')"
        >
          <span class="menu-tooltip">{{ $t('pages.room.tooltip.addMember') }}</span>
          <img :src="require('@/assets/images/room/icons/add_member.png')"/>
        </div>
        <div
          class="menu exit"
          @click="$emit('onClickExit')"
        >
          <span class="menu-tooltip">{{ $t('pages.room.tooltip.exitRoom') }}</span>
          <img :src="require('@/assets/images/room/icons/exit.png')"/>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'RoomControl',
  props: {
    videoRoom: Object,
    cafeRoom: Boolean,
    isOwner: Boolean,
    peersInfoState: Boolean,
    whiteboardState: Boolean,
    screenShareState: {
      type: Number,
      default: 0
    },
    chatState: Boolean,
    myWebcamState: Boolean,
    myMicState: Boolean,
    myRaisedHandsState: Boolean,
    newChatMessagesState: {
      type: Number,
      default: 0
    },
    raisedHandsPeersState: {
      type: Number,
      default: 0
    },
    addMemberModalState: Boolean
  },
  data() {
    return {
      enabledBadge: false,
      enabledMenu: false,
      elapsedTimeCalculateInterval: null,
      elapsedTime: null
    }
  },
  created () {
    if (!this.cafeRoom) {
      this.diffDurationInterval = setInterval(() => {
        const now = moment(new Date)
        const startAt = moment(this.videoRoom.startAt)
        const diffDuration = moment.duration(now.diff(startAt))
        const minutes = `0${diffDuration.minutes()}`.slice(-2)
        const seconds = `0${diffDuration.seconds()}`.slice(-2)
        this.elapsedTime = diffDuration.hours() ?
                           `${`0${diffDuration.hours()}`.slice(-2)}：${minutes}：${seconds}` :
                           `${minutes}：${seconds}`
      }, 1000)
    }
  },
  beforeDestroy: function () {
    if (this.diffDurationInterval) clearInterval(this.diffDurationInterval)
  },
  watch: {
    newChatMessagesState: function(value) {
      if (!this.enabledMenu && !this.enabledBadge && value != 0) {
        this.enabledBadge = true
      }

      if (value == 0 && this.raisedHandsPeersState == 0) {
        this.enabledBadge = false
      }
    },
    raisedHandsPeersState: function(value) {
      if (!this.enabledMenu && !this.enabledBadge && value != 0) {
        this.enabledBadge = true
      }

      if (value == 0 && this.newChatMessagesState == 0) {
        this.enabledBadge = false
      }
    }
   }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.room-control {
  z-index: 1000;
  color: white;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row-reverse;
  bottom: 20px;
  right: 20px;

  @include mq(md) {
    bottom: 40px;
    right: 40px;
  }

  .menu-tooltip {
    display: none;
    position: absolute;
    width: max-content;
    padding: 4px 6px;
    border-radius: 4px;
    bottom: calc(100% + 12px);
    background-color: #505050;
    color: $background-color;
  }

  .room-control-button {
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #323232;
    border-radius: 50%;
    box-shadow: 0px 0px 10px #00000066;
    cursor: pointer;

    &:hover {
      background-color: #505050;

      .menu-tooltip {
        @include mq(md) {
          display: block;
        }
      }
    }

    img {
      width: 18px;
      height: 18px;
    }
  }

  .room-control-menu {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 50px;
    margin-right: 10px;
    padding: 6px 20px;
    background-color: #323232;
    border-radius: 25px;
    box-shadow: 0px 0px 10px #00000066;
    font-size: 13px;
    color: $light-text-color;
    width: calc(100vw - 100px);
    overflow-x: auto;

    &:after {
      display: block;
      content: "";
      padding: 10px;
    }

    @include mq(md) {
      justify-content: center;
      width: auto !important;
      overflow: visible;

      &:after {
        padding: 0;
      }
    }


    .elapsed-time {
      white-space: nowrap;
    }

    .menu {
      position: relative;
      display: flex;
      justify-content: center;
      cursor: pointer;
      padding: 6px;
      border-radius: 4px;
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }

      &:hover .menu-tooltip {
        @include mq(md) {
          display: block;
        }
      }

      &:hover:not(.disabled):not(.exit) {
        background-color: #505050;
      }

      &.active {
        background-color: #1E1E1E;
      }

      &.disabled {
        opacity: 0.5;
        cursor: default;
        pointer-events: none;
      }

      &.exit {
        background-color: #C80000;
      }

      img {
        width: 26px;
        height: 26px;
      }
    }
  }
}

.room-control-badge {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 14px;
  height: 14px;
  top: 0;
  right: 0;
  border-radius: 50%;
  font-size: 9px;
  background-color: #C80000;
  color: white;
}

.scale-enter-active {
  animation: scale-in .3s;
}

.scale-leave-active {
  animation: scale-in .3s reverse;
}

@keyframes scale-in {
  0% {
    opacity: 0;
    transform-origin: right center;
    transform: scaleX(0);
  }
  100% {
    opacity: 1;
    transform-origin: right center;
    transform: scaleX(1);
  }
}
</style>
